<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.cr_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="cr_date">
            <label class="weui-form-preview__label">{{customLabel.cr_date || "单据日期"}}</label>
            <span class="weui-form-preview__value">{{form.main.cr_date}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cr_iocode">
            <label class="weui-form-preview__label">{{customLabel.cr_iocode || "领料单号"}}</label>
            <span class="weui-form-preview__value">{{form.main.cr_iocode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cr_custname">
            <label class="weui-form-preview__label">{{customLabel.cr_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.cr_custname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cr_macode">
            <label class="weui-form-preview__label">{{customLabel.cr_macode || "客户PO"}}</label>
            <span class="weui-form-preview__value">{{form.main.cr_macode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cr_prodcode">
            <label class="weui-form-preview__label">{{customLabel.cr_prodcode || "产品编号"}}</label>
            <span class="weui-form-preview__value">{{form.main.cr_prodcode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_detail}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" slot="pi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" slot="pi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" slot="pi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" slot="pi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" slot="pi_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.crd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家品牌"}}</label>
              <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_whname">
              <label class="weui-form-preview__label">{{customLabel.crd_whname || "仓库"}}</label>
              <span class="weui-form-preview__value">{{item.crd_whname}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_inqty">
              <label class="weui-form-preview__label">{{customLabel.crd_inqty || "数量"}}</label>
              <span class="weui-form-preview__value">{{item.crd_inqty}} {{item.productDTO.pr_unit}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_qty_extra" v-if="item.crd_qty_extra">
              <label class="weui-form-preview__label">{{
                customLabel.crd_qty_extra || "辅助数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.crd_qty_extra }} {{ item.productDTO.pr_unit_extra }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="crd_batchcode">
              <label class="weui-form-preview__label">{{customLabel.crd_batchcode || "批次号"}}</label>
              <span class="weui-form-preview__value">{{item.crd_batchcode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_madetime">
              <label class="weui-form-preview__label">{{customLabel.crd_madetime || "生产日期"}}</label>
              <span class="weui-form-preview__value">{{item.crd_madetime}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_shelflife">
              <label class="weui-form-preview__label">{{customLabel.crd_shelflife || "保质期（天）"}}</label>
              <span class="weui-form-preview__value">{{item.crd_shelflife}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_lifedate">
              <label class="weui-form-preview__label">{{customLabel.crd_lifedate || "保质期"}}</label>
              <span class="weui-form-preview__value">{{item.crd_lifedate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_price">
              <label class="weui-form-preview__label">{{customLabel.crd_price || "成本单价(元)"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.crd_price,'#,##0.####')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_total">
              <label class="weui-form-preview__label">{{customLabel.crd_total || "金额(元)"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.crd_total,'#,##0.00')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="crd_remark">
              <label class="weui-form-preview__label">{{customLabel.crd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{item.crd_remark}}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" slot="pd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" slot="pd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" slot="pd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" slot="pd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" slot="pd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/storage/customerReceive",
      caller: "CustomerReceive",
      xtype: "stock-customerReceive-formpanel",
    };
  }
};
</script>